<template>
  <div
    class="password-container w-[343px] px-4 py-6 min-h-[195px] rounded-[10px] bg-[#151A1F] border-[2px] border-solid border-[var(--theme-gray100)] flex flex-col justify-center items-center sendPassword"
  >
    <Image
      :src="close"
      class="w-[24px] h-[24px] !absolute top-2 right-2"
      alt=""
      @click="handleClose"
    />
    <div class="text-white mb-8 text-[16px]">
      {{ $t("Saque.SendPassword.CheckWithdrawalPassword") }}
    </div>
    <div class="input-box flex justify-between w-full px-2" @click="focusInput">
      <div
        v-for="(_, index) in 6"
        :key="index"
        :class="[
          'box w-[40px] h-[40px] flex items-center justify-center rounded-[6px]',
          index == password.length && isFocused
            ? '  border-[1px] border-solid  border-[var(--theme-gray-gold)] active'
            : '',
        ]"
      >
        <span
          v-if="index < password.length"
          class="dot bg-white w-[10px] h-[10px] rounded-full"
        ></span>
        <span
          v-if="index == password.length && isFocused"
          class="bg-white w-[1px] h-[12px] animate-blink"
        ></span>
      </div>
    </div>
    <van-field
      ref="hiddenInput"
      class="hidden-input absolute top-[-1000px] opacity-0 pointer-events-none h-0"
      v-model="password"
      inputmode="numeric"
      maxlength="6"
      @input="handleInput"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />

    <div
      v-if="passwordError"
      class="text-[13px] flex gap-2 text-[#FF3B30] leading-[18px] mt-4"
    >
      <Image class="w-[16px] h-[16px]" :src="sigh" alt="" />
      <span> {{ $t("Saque.SendPassword.PasswordErrorMessage") }}</span>
    </div>

    <van-button
      @click="handleConfirm"
      :disabled="password.length !== 6"
      :class="[
        'w-full mt-8',
        password.length == 6 ? 'primaryBtn' : 'primaryBtn_transparent',
      ]"
    >
      {{ $t("Common.Confirm") }}
    </van-button>
  </div>
</template>

<script setup lang="ts">
import { checkWithdrawalPassword } from "@/api/saque";
import sigh from "../images/sigh.png";
import close from "../images/close.png";
import { encryptPassword } from "@/utils";
const hiddenInput = ref<HTMLInputElement | null>(null);
const password = ref("");
const isFocused = ref(false);
const emit = defineEmits(["confirm", "close"]);
const passwordError = ref(false);
const focusInput = () => {
  hiddenInput.value?.focus();
};

const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/[^0-9]/g, "");
  password.value = input.value.slice(0, 6);
};

const handleClose = () => {
  emit("close");
};
// 校验密码
const handleConfirm = async () => {
  const loadingToast = showLoadingToast({
    message: "loading...",
    forbidClick: true,
    duration: 0,
    zIndex: 9999,
  });
  hiddenInput.value?.blur();
  try {
    const res: any = await checkWithdrawalPassword({
      value: encryptPassword(password.value),
    });
    if (res.code === 1) {
      emit("confirm", encryptPassword(password.value));
    }
    if (res.code === -3709) {
      passwordError.value = true;
    }

  } finally {
    loadingToast.close();
  }
};

onMounted(() => {
  focusInput();
});
</script>

<style scoped lang="scss">
.password-container {
  position: relative;
  .box {
    background-color: var(--inner-table-bg-color100);
  }
  .confirm-button:disabled {
    background-color: #555;
    cursor: not-allowed;
  }
  .animate-blink {
    animation: blink 1s infinite;
  }
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
